export default __webpack_public_path__ + "static/media/iceCream.8e081da2.jpg";